<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Door Display Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="exam_plan" item-value="id"
                        :items="exam_plan_list" item-text="plan_name" label="Exam Plan" outlined
                        persistent-hint hint="Please Select Exam Plan" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="exam_room" item-value="id"
                        :items="room_list" item-text="room_number" label="Exam Room" outlined persistent-hint
                        hint="Please Select Exam Room" />
                </v-col>
                 <v-col cols="12" sm="2" md="2" class="pt-8 pl-2 mt-1" v-if="exam_plan && exam_room !== ''">
                    <v-btn color="primary" @click="fetchDoorDisplayReport()" small> Fetch </v-btn>
                </v-col>
            </v-row>
            <br>
            <div v-if="reportFetched">
            <v-row dense align="center">
                        <v-col cols="auto" class="pa-0">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small
                                class="mt-2 ml-2">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export EXCEL
                            </v-btn>
                        </v-col>

                        <v-col cols="auto" class="pa-0 pl-1">
                            <v-btn rounded color="error" outlined @click="printPDF" small class="mt-2">
                                <v-icon left color="error">mdi-file-pdf-box</v-icon>
                                Export PDF
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>

                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        clearable
                        class="search-field"
                    ></v-text-field>

                    </v-row>
            <v-row >
                            <v-col cols="12" sm="" md="2" align="center">
                                <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                                <h3 class="report_name">Door Display Report</h3>
                               
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>
            <v-simple-table  fixed-header height="500px" dense class="elevation-1 scroll table-data">
                
                        <thead>
                                <tr>
                                    <th class="sticky-header"><center>S. No.</center></th>
                                    <th class="sticky-header"><center>PRN No.</center></th>
                                    <th class="sticky-header"><center>Roll No.</center></th>
                                    <th class="sticky-header"><center>Student Name</center></th>
                                    <th class="sticky-header"><center>Session No.</center></th>
                                    <th class="sticky-header"><center>Exam Date</center></th>
                                    <th class="sticky-header"><center>Exam Day</center></th>
                                    <th class="sticky-header"><center>Slot No</center></th>
                                    <th class="sticky-header"><center>From Time</center></th>
                                    <th class="sticky-header"><center>To Time</center></th>
                                    <th class="sticky-header"><center>Subject Code</center></th>
                                    <th class="sticky-header"><center>Subject Name</center></th>
                                    <th class="sticky-header"><center>Conduct Type</center></th>
                                    <th class="sticky-header"><center>Room No</center></th>
                                    <th class="sticky-header"><center>Bench No</center></th>
                                    <th class="sticky-header"><center>Bench Side</center></th>
                                    <th class="sticky-header"><center>Standard</center></th>
                                    <th class="sticky-header"><center>Division</center></th>
                                    <th class="sticky-header"><center>Stream</center></th>
                                    <th class="sticky-header"><center>Exam Plan</center></th>
                                    <th class="sticky-header"><center>Academic Year</center></th>
                                    <th class="sticky-header"><center>Semester</center></th>

                                </tr>
                        </thead>
                        <tbody style="overflow-y: scroll; border: 1px solid #ccc;">
                                <tr v-for="(s, index) in filteredDoorDisplayReport" :key="s.cid || index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.prn }}</td>
                                    <td>{{ s.rollno }}</td>
                                    <td>{{ s.student_name }}</td>
                                    <td>{{ s.session_no }}</td>
                                    <td>{{ s.exam_date }}</td>
                                    <td>{{ s.exam_day }}</td>
                                    <td>{{ s.slot_no }}</td>
                                    <td>{{ s.from_time }}</td>
                                    <td>{{ s.to_time }}</td>
                                    <td>{{ s.subject_code }}</td>
                                    <td>{{ s.subject_name }}</td>
                                    <td>{{ s.conduct_type }}</td>
                                    <td>{{ s.room_no }}</td>
                                    <td>{{ s.bench_no }}</td>
                                    <td>{{ s.bench_side }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.division }}</td>
                                    <td>{{ s.stream }}</td>
                                    <td>{{ s.exam_plan }}</td>
                                    <td>{{ s.ay }}</td>
                                    <td>{{ s.semester }}</td>
                            </tr>
                        </tbody>


            </v-simple-table>
            </div>

            <div id="pdf-report" class="pdf-report">
                <v-row>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                            <v-col cols="12" sm="8" md="8" align="center">
                                <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                                    {{ org_basic_data.trust_name }}
                                </h2>
                                <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                                    {{ org_basic_data.school_name }}</h2>
                                <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                                <h2 class="report_name">Door Display Report</h2>
                               
                            </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>

                <!-- <h2>Door Display Report</h2> -->

                <table>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>PRN</th>
                            <th>Roll No</th>
                            <th>Student Name</th>
                            <th>Session No</th>
                            <th>Exam Date</th>
                            <th>Exam Day</th>
                            <th>Slot No</th>
                            <th>From Time</th>
                            <th>To Time</th>
                            <th>Subject Code</th>
                            <th>Subject Name</th>
                            <th>Conduct Type</th>
                            <th>Room No</th>
                            <th>Bench No</th>
                            <th>Bench Side</th>
                            <th>Standard</th>
                            <th>Division</th>
                            <th>Stream</th>
                            <th>Exam Plan</th>
                            <th>Academic Year</th>
                            <th>Semester</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in door_display_report" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.prn }}</td>
                            <td>{{ item.rollno }}</td>
                            <td>{{ item.student_name }}</td>
                            <td>{{ item.session_no }}</td>
                            <td>{{ item.exam_date }}</td>
                            <td>{{ item.exam_day }}</td>
                            <td>{{ item.slot_no }}</td>
                            <td>{{ item.from_time }}</td>
                            <td>{{ item.to_time }}</td>
                            <td>{{ item.subject_code }}</td>
                            <td>{{ item.subject_name }}</td>
                            <td>{{ item.conduct_type }}</td>
                            <td>{{ item.room_no }}</td>
                            <td>{{ item.bench_no }}</td>
                            <td>{{ item.bench_side }}</td>
                            <td>{{ item.standard }}</td>
                            <td>{{ item.division }}</td>
                            <td>{{ item.stream }}</td>
                            <td>{{ item.exam_plan }}</td>
                            <td>{{ item.ay }}</td>
                            <td>{{ item.semester }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
export default {
    data: () => ({
        valid: false,
        overlay: false,
        loader:false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        org_basic_data: [],
        search: "",
        dialog: false,
        reportFetched: false,
        
        exam_plan:"",
        exam_room:"",
        headers: [
            {
                text: "S.No",
                align: "left",
                sortable: false,
                value: "srno",
            },
            {
                text: "PRN",
                align: "left",
                sortable: false,
                value: "prn",
            },
            {
                text: "Roll No",
                align: "left",
                sortable: false,
                value: "rollno",
            },
            {
                text: "Student Name",
                align: "left",
                sortable: true,
                value: "student_name",
            },
            {
                text: "Session No.",
                align: "left",
                sortable: true,
                value: "session_no",
            },
            {
                text: "Exam Date",
                align: "left",
                sortable: true,
                value: "exam_date",
            },
            {
                text: "Exam Day",
                align: "left",
                sortable: true,
                value: "exam_day",
            },
            {
                text: "Slot No",
                align: "left",
                sortable: true,
                value: "slot_no",
            },
            {
                text: "From Time",
                align: "left",
                sortable: true,
                value: "from_time",
            },
            {
                text: "To Time",
                align: "left",
                sortable: true,
                value: "to_time",
            },
            {
                text: "Subject Code",
                align: "left",
                sortable: true,
                value: "subject_code",
            },
            {
                text: "Subject Name",
                align: "left",
                sortable: true,
                value: "subject_name",
            },
            {
                text: "Conduct Type",
                align: "left",
                sortable: true,
                value: "conduct_type",
            },
            {
                text: "Room No.",
                align: "left",
                sortable: true,
                value: "room_no",
            },
            {
                text: "Bench No",
                align: "left",
                sortable: true,
                value: "bench_no",
            },
            {
                text: "Bench Side",
                align: "left",
                sortable: true,
                value: "bench_side",
            },
            {
                text: "Standard",
                align: "left",
                sortable: true,
                value: "standard",
            },
            {
                text: "Division",
                align: "left",
                sortable: true,
                value: "division",
            },
            {
                text: "Stream",
                align: "left",
                sortable: true,
                value: "stream",
            },
            {
                text: "Exam Plan",
                align: "left",
                sortable: true,
                value: "exam_name",
            },
            {
                text: "Academic Year",
                align: "left",
                sortable: true,
                value: "ay",
            },
            {
                text: "Semester",
                align: "left",
                sortable: true,
                value: "semester",
            },
        ],
        exam_plan_list: [],
        room_list:[],
        door_display_report:[],
        editedIndex: -1,
    }),

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },

    computed: {
        filteredDoorDisplayReport() {
            const data = this.door_display_report || [];
            const query = (this.search || "").toLowerCase().trim();

            if (!query) {
                return data;
            }

            return data.filter(item => {
                return Object.values(item).some(value =>
                    String(value == null ? "" : value)
                        .toLowerCase()
                        .includes(query)
                );
            });
        }
    },

    mounted() {
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getPlanAndRoomList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.exam_plan_list = res.data.exam_plan_list;
                        this.room_list = res.data.room_list;
                        
                        if(this.room_list.length>0){
                            this.room_list = [
                                { id: null, room_number: "All" },
                                ...(res.data.room_list || [])
                            ];
                        }
                        const savedPlan = localStorage.getItem("exam_plan");

                        if (savedPlan) {
                            this.exam_plan = Number(savedPlan);
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        fetchDoorDisplayReport() {
            this.overlay = true;
            this.reportFetched = false;
            this.door_display_report = [];
            this.org_basic_data = [];

            const data = {
                exam_plan: this.exam_plan,
                exam_room: this.exam_room
            };

            axios
                .post("/SeatingArrangement/fetchDoorDisplayReport", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.door_display_report =
                            res.data.door_display_report || [];

                        this.org_basic_data =
                            res.data.org_basic_data || [];

                        this.reportFetched = true;
                    } else {
                        this.showSnackbar(
                            "#b71c1c",
                            "No data available."
                        );
                    }
                })
                .catch((error) => {
                    this.showSnackbar(
                        "#b71c1c",
                        "Something went wrong..."
                    );
                    console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        close() {
            this.dialog = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        downloadFile() {
            this.loader = true;
            const excelData = this.door_display_report.map((item, index) => ({
                "S.No": index + 1,
                "PRN": item.prn,
                "Roll No": item.rollno,
                "Student Name": item.student_name,
                "Session No": item.session_no,
                "Exam Date": item.exam_date,
                "Exam Day": item.exam_day,
                "Slot No": item.slot_no,
                "From Time": item.from_time,
                "To Time": item.to_time,
                "Subject Code": item.subject_code,
                "Subject Name": item.subject_name,
                "Conduct Type": item.conduct_type,
                "Room No": item.room_no,
                "Bench No": item.bench_no,
                "Bench Side": item.bench_side,
                "Standard": item.standard,
                "Division": item.division,
                "Stream":item.stream,
                "Exam Plan":item.exam_plan,
                "Academic Year": item.ay,
                "Semester": item.semester
            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Door Display Report");
            XLSX.writeFile(workbook, "DoorDisplayReport.xlsx");
            this.loader = false;
        },

        printPDF() {
            if (!this.door_display_report || this.door_display_report.length === 0) {
                this.showSnackbar("#b71c1c", "No data available for PDF export.");
                return;
            }

            window.print();
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.pdf-report {
    display: none;
}

.pdf-report {
    display: none;
}


@media print {
    @page {
        size: A3 landscape;
        /* margin: 0mm 0mm 5mm 0mm; */
        margin-left: -50px;
    }

    html,
    body {
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
    }

    body * {
        visibility: hidden;
    }

    #pdf-report,
    #pdf-report * {
        visibility: visible;
    }

    #pdf-report {
        display: block !important;
        position: absolute;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
    }

    /* Reduce space above the school header */
    #pdf-report > .v-row {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    #pdf-report .v-col {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    #pdf-report h2 {
        text-align: center;
        margin-top: 0 !important;
        margin-bottom: 3px !important;
        padding: 0 !important;
        font-size: 25px !important;
    }

    #pdf-report h3 {
        margin-top: 0 !important;
        margin-bottom: 4px !important;
    }

    #pdf-report .print-logo {
        margin-top: 0 !important;
    }

    #pdf-report table {
        width: 100% !important;
        max-width: none !important;
        border-collapse: collapse !important;
        margin: 0 !important;
        font-size: 13px !important;
    }

    #pdf-report th,
    #pdf-report td {
        border: 1px solid #000 !important;
        padding: 3px !important;
        text-align: center !important;
        vertical-align: middle !important;
        font-size: 14px !important;
    }

    #pdf-report th {
        font-weight: bold;
    }

    #pdf-report thead {
        display: table-header-group;
    }

    #pdf-report tr {
        page-break-inside: avoid;
    }
}



</style>